import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';
import { Pill } from '@hivebrite/design-system/Pill';

import { UserName } from './UserName';
import type { NotifyUser } from '../types';

interface SelectedUserMobileProps {
  removeUser: (user: NotifyUser) => void;
  user: NotifyUser;
}

const SelectedUserMobile = ({ removeUser, user }: SelectedUserMobileProps) => (
  <Box justifyContent="space-between" alignItems="center" mb={3}>
    <Box alignItems="center">
      <UserName user={user} />
      {user.isRecommended && (
        <Box ml={4}>
          <Pill>{s__('NotifyPeople|Suggested user')}</Pill>
        </Box>
      )}
    </Box>
    <Box>
      <RemoveButton
        aria-label={s__('NotifyPeople|Remove %{userName} from the list').i__({
          userName: user.name,
        })}
        type="button"
        onClick={() => removeUser(user)}
      >
        <FontAwesomeIcon
          color="primary"
          height="20px"
          iconName="xmark"
          iconType={CATEGORIES.SOLID}
        />
      </RemoveButton>
    </Box>
  </Box>
);

export default SelectedUserMobile;

const RemoveButton = styled.button`
  appearance: none;
  padding: 8px;
  border: 0;
  background-color: transparent;
`;
